import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { WebsiteComponent } from './components/website/website.component';
import { CardComponent } from './components/card/card.component';
import { UpperclubComponent } from './components/upperclub/upperclub.component';
import { BrandedRulesComponent } from './components/branded-rules/branded-rules.component';
import { CyberComponent } from './components/cyber/cyber.component';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FirstcitizensComponent } from './pages/firstcitizens/firstcitizens.component';

import { AppRoutingModule } from './app.routing';
import { MilesUpperProgramComponent } from './components/miles-upper-program/miles-upper-program.component';
import { MilesUpperGeneralComponent } from './components/miles-upper-general/miles-upper-general.component';
import { MilesUpperBenefitsComponent } from './components/miles-upper-benefits/miles-upper-benefits.component';
import { StayCareComponent } from './components/stay-care/stay-care.component';
import { FlyCareComponent } from './components/fly-care/fly-care.component';
import { OtherBenefitsComponent } from './components/other-benefits/other-benefits.component';
import { ExclusionsComponent } from './components/exclusions/exclusions.component';
import { CoverageComponent } from './components/coverage/coverage.component';
import { ServiceComponent } from './components/service/service.component';
import { GlosaryComponent } from './components/glosary/glosary.component';
import { BestPriceComponent } from './components/best-price/best-price.component';
import { ProgramDefinitionFcComponent } from './components/program-definition-fc/program-definition-fc.component';
import { NcbComponent } from './pages/ncb/ncb.component';
import { ProgramDefinitionNcbComponent } from './components/program-definition-ncb/program-definition-ncb.component';
import { MyrewardsComponent } from './pages/myrewards/myrewards.component';
import { RewardsComponent } from './components/rewards/rewards.component';
import { RewardsAppComponent } from './components/rewards-app/rewards-app.component';
import { VoyageComponent } from './components/voyage/voyage.component';
import { OffersComponent } from './components/offers/offers.component';
import { PrivacyNoticeComponent } from './components/privacy-notice/privacy-notice.component';
import { PrivacyNoticeMrComponent } from './components/privacy-notice-mr/privacy-notice-mr.component';
import { VoyageBenefitsComponent } from './components/voyage-benefits/voyage-benefits.component';
import { DefinitionsComponent } from './components/definitions/definitions.component';
import { CoverageProvisionsComponent } from './components/coverage-provisions/coverage-provisions.component';
import { FlyAndStayComponent } from './components/fly-and-stay/fly-and-stay.component';
import { OtherBenefitsMrComponent } from './components/other-benefits-mr/other-benefits-mr.component';
import { BestPriceMrComponent } from './components/best-price-mr/best-price-mr.component';
import { ExclusionsMrComponent } from './components/exclusions-mr/exclusions-mr.component';
import { ProgramDefinitionComponent } from './components/program-definition/program-definition.component';
import { MilesUseComponent } from './components/miles-use/miles-use.component';
import { LifemilesComponent } from './pages/lifemiles/lifemiles.component';
import { MilesCareProtectionComponent } from './components/miles-care-protection/miles-care-protection.component';
import { BusinessModelComponent } from './components/business-model/business-model.component';
import { AdditionalProtectionComponent } from './components/additional-protection/additional-protection.component';
import { MiscellaneousCoverageComponent } from './components/miscellaneous-coverage/miscellaneous-coverage.component';
import { GeneralInformationComponent } from './components/general-information/general-information.component';
import { StayCareLifeComponent } from './components/stay-care-life/stay-care-life.component';
import { FlyCareLifeComponent } from './components/fly-care-life/fly-care-life.component';
import { GeneralConditionsLifeComponent } from './components/general-conditions-life/general-conditions-life.component';
import { CyberRiskComponent } from './components/cyber-risk/cyber-risk.component';
import { ExclusionsLmComponent } from './components/exclusions-lm/exclusions-lm.component';
import { CoverageProvisionsMrComponent } from './components/coverage-provisions-mr/coverage-provisions-mr.component';
import { ScotiaComponent } from './pages/scotia/scotia.component';
import { GeneralConditionsScotiaComponent } from './components/general-conditions-scotia/general-conditions-scotia.component';
import { ProgramDefinitionScotiaComponent } from './components/program-definition-scotia/program-definition-scotia.component';
import { ScotiaRewardsComponent } from './components/scotia-rewards/scotia-rewards.component';
import { CoverageProvisionsScotiaComponent } from './components/coverage-provisions-scotia/coverage-provisions-scotia.component';
import { StayCareScotiaComponent } from './components/stay-care-scotia/stay-care-scotia.component';
import { FlyCareScotiaComponent } from './components/fly-care-scotia/fly-care-scotia.component';
import { OtherBenefitsScotiaComponent } from './components/other-benefits-scotia/other-benefits-scotia.component';
import { ExclusionsScotiaComponent } from './components/exclusions-scotia/exclusions-scotia.component';
import { CoverageInformationComponent } from './components/coverage-information/coverage-information.component';
import { CredomaticComponent } from './pages/credomatic/credomatic.component';
import { GeneralConditionsCredomaticComponent } from './components/general-conditions-credomatic/general-conditions-credomatic.component';
import { ProgramDefinitionCredomaticComponent } from './components/program-definition-credomatic/program-definition-credomatic.component';
import { CoverageProvisionsCredomaticComponent } from './components/coverage-provisions-credomatic/coverage-provisions-credomatic.component';
import { StayCareCredomaticComponent } from './components/stay-care-credomatic/stay-care-credomatic.component';
import { FlyCareCredomaticComponent } from './components/fly-care-credomatic/fly-care-credomatic.component';
import { GlosaryCredomaticComponent } from './components/glosary-credomatic/glosary-credomatic.component';
import { OtherBenefitsCredomaticComponent } from './components/other-benefits-credomatic/other-benefits-credomatic.component';
import { CyberRiskCredomaticComponent } from './components/cyber-risk-credomatic/cyber-risk-credomatic.component';
import { CoverageCredomaticComponent } from './components/coverage-credomatic/coverage-credomatic.component';
import { LifemilesParthersComponent } from './pages/lifemiles-parthers/lifemiles-parthers.component';
import { ProgramDefinitionLmpComponent } from './components/program-definition-lmp/program-definition-lmp.component';
import { LifeMilesAirlineComponent } from './components/life-miles-airline/life-miles-airline.component';
import { PrivacyNoticeLmpComponent } from './components/privacy-notice-lmp/privacy-notice-lmp.component';
import { VoyageBenefitsFlyCareComponent } from './components/voyage-benefits-fly-care/voyage-benefits-fly-care.component';
import { CibcComponent } from './pages/cibc/cibc.component';
import { ProgramDefinitionMrComponent } from './components/program-definition-mr/program-definition-mr.component';
import { PrivacyNoticeCibcComponent } from './components/privacy-notice-cibc/privacy-notice-cibc.component';
import { VoyageBenefitsCibcComponent } from './components/voyage-benefits-cibc/voyage-benefits-cibc.component';
import { MoreRateComponent } from './components/more-rate/more-rate.component';
import { ProgramDefinitionCibcComponent } from './components/program-definition-cibc/program-definition-cibc.component';
import { ExclusionsCredomaticComponent } from './components/exclusions-credomatic/exclusions-credomatic.component';
import { ApapComponent } from './pages/apap/apap.component';
import { ProgramDefinitionApapComponent } from './components/program-definition-apap/program-definition-apap.component';
import { CyberRiskLmComponent } from './components/cyber-risk-lm/cyber-risk-lm.component';
import { CoverageDispositionsComponent } from './components/coverage-dispositions/coverage-dispositions.component';
import { WebAppCredomaticComponent } from './components/web-app-credomatic/web-app-credomatic.component';
import { CareComponent } from './pages/care/care.component';
import { ProgramDefinitionCareComponent } from './components/program-definition-care/program-definition-care.component';
import { ServiceCareComponent } from './components/service-care/service-care.component';
import { OtherBenefitsCareComponent } from './components/other-benefits-care/other-benefits-care.component';
import { ScotiaRewardsFixedComponent } from './components/scotia-rewards-fixed/scotia-rewards-fixed.component';
import { ScotiaRewardsEnrollmentComponent } from './components/scotia-rewards-enrollment/scotia-rewards-enrollment.component';
import { ScotiaRewardsCommunicationsComponent } from './components/scotia-rewards-communications/scotia-rewards-communications.component';
import { WebsiteScotiaComponent } from './components/website-scotia/website-scotia.component';
import { CoverageInformationScotiaComponent } from './components/coverage-information-scotia/coverage-information-scotia.component';
import { GlosaryScotiaComponent } from './components/glosary-scotia/glosary-scotia.component';
import { MilesBlueComponent } from './pages/miles-blue/miles-blue.component';
import { CibcAppComponent } from './components/cibc-app/cibc-app.component';
import { FlexwayComponent } from './components/flexway/flexway.component';
import { FlexwayScotiaComponent } from './components/flexway-scotia/flexway-scotia.component';
import { RewardsApapAppComponent } from './components/rewards-apap-app/rewards-apap-app.component';
import { VoyageBenefitsApapComponent } from './components/voyage-benefits-apap/voyage-benefits-apap.component';
import { CyberRiskProtectionNcbComponent } from './components/cyber-risk-protection-ncb/cyber-risk-protection-ncb.component';
import { CryptmiComponent } from './pages/cryptmi/cryptmi.component';
import { ProgramDefinitionCryptmiComponent } from './components/program-definition-cryptmi/program-definition-cryptmi.component';
import { PrivacyCryptmiComponent } from './components/privacy-cryptmi/privacy-cryptmi.component';
import { GeneralConditionsCryptmiComponent } from './components/general-conditions-cryptmi/general-conditions-cryptmi.component';
import { StayCareCryptmiComponent } from './components/stay-care-cryptmi/stay-care-cryptmi.component';
import { FlyCareCryptmiComponent } from './components/fly-care-cryptmi/fly-care-cryptmi.component';
import { OtherBenefitsCryptmiComponent } from './components/other-benefits-cryptmi/other-benefits-cryptmi.component';
import { ExclusionsCryptmiComponent } from './components/exclusions-cryptmi/exclusions-cryptmi.component';
import { CoverageInformationCryptmiComponent } from './components/coverage-information-cryptmi/coverage-information-cryptmi.component';
import { WebsiteCryptmiComponent } from './components/website-cryptmi/website-cryptmi.component';
import { ServiceCryptmiComponent } from './components/service-cryptmi/service-cryptmi.component';
import { GlossaryMilesBlueComponent } from './components/glossary-miles-blue/glossary-miles-blue.component';
import { ProgramDefinitionMilesBlueComponent } from './components/program-definition-miles-blue/program-definition-miles-blue.component';
import { GeneralConditionsMilesBlueComponent } from './components/general-conditions-miles-blue/general-conditions-miles-blue.component';
import { OtherBenefitsMilesBlueComponent } from './components/other-benefits-miles-blue/other-benefits-miles-blue.component';
import { CoverageInformationMilesBlueComponent } from './components/coverage-information-miles-blue/coverage-information-miles-blue.component';
import { CyberRiskMilesBlueComponent } from './components/cyber-risk-miles-blue/cyber-risk-miles-blue.component';
import { ServiceMilesBlueComponent } from './components/service-miles-blue/service-miles-blue.component';
import { MilesComponent } from './pages/miles/miles.component';
import { ProgramDefinitionMilesComponent } from './components/program-definition-miles/program-definition-miles.component';
import { MilesAppComponent } from './components/miles-app/miles-app.component';
import { VoyageBenefitsMilesComponent } from './components/voyage-benefits-miles/voyage-benefits-miles.component';
import { CoverageProvisionsMilesComponent } from './components/coverage-provisions-miles/coverage-provisions-miles.component';
import { FlyAndStayMilesComponent } from './components/fly-and-stay-miles/fly-and-stay-miles.component';
import { OtherBenefitsMilesComponent } from './components/other-benefits-miles/other-benefits-miles.component';
import { ExclusionsMilesComponent } from './components/exclusions-miles/exclusions-miles.component';
import { ChnComponent } from './pages/chn/chn.component';
import { ProgramDefinitionChnComponent } from './components/program-definition-chn/program-definition-chn.component';
import { VoyageBenefitsChnComponent } from './components/voyage-benefits-chn/voyage-benefits-chn.component';
import { CoverageProvisionsChnComponent } from './components/coverage-provisions-chn/coverage-provisions-chn.component';
import { OtherBenefitsChnComponent } from './components/other-benefits-chn/other-benefits-chn.component';
import { ExclusionsChnComponent } from './components/exclusions-chn/exclusions-chn.component';
import { GenniusComponent } from './pages/gennius/gennius.component';
import { CuscatlanComponent } from './pages/cuscatlan/cuscatlan.component';
import { ProgramDefinitionCuscatlanComponent } from './components/program-definition-cuscatlan/program-definition-cuscatlan.component';
import { VoyageBenefitsCuscatlanComponent } from './components/voyage-benefits-cuscatlan/voyage-benefits-cuscatlan.component';
import { CoverageProvisionsCuscatlanComponent } from './components/coverage-provisions-cuscatlan/coverage-provisions-cuscatlan.component';
import { FlyAndStayCuscatlanComponent } from './components/fly-and-stay-cuscatlan/fly-and-stay-cuscatlan.component';
import { OtherBenefitsCuscatlanComponent } from './components/other-benefits-cuscatlan/other-benefits-cuscatlan.component';
import { ExclusionsCuscatlanComponent } from './components/exclusions-cuscatlan/exclusions-cuscatlan.component';
import { FlexwayBacComponent } from './components/flexway-bac/flexway-bac.component';
import { ImagineComponent } from './pages/imagine/imagine.component';
import { ProgramDefinitionImagineComponent } from './components/program-definition-imagine/program-definition-imagine.component';
import { FlexwayImagineComponent } from './components/flexway-imagine/flexway-imagine.component';
import { WebsiteImagineComponent } from './components/website-imagine/website-imagine.component';
import { FlyCareImagineComponent } from './components/fly-care-imagine/fly-care-imagine.component';
import { CoverageDispositionsImagineComponent } from './components/coverage-dispositions-imagine/coverage-dispositions-imagine.component';
import { ServiceImagineComponent } from './components/service-imagine/service-imagine.component';
import { NcbAppComponent } from './components/ncb-app/ncb-app.component';
import { VoyageBenefitsNcbComponent } from './components/voyage-benefits-ncb/voyage-benefits-ncb.component';
import { OneComponent } from './pages/one/one.component';
import { GlossaryOneComponent } from './components/glossary-one/glossary-one.component';
import { ProgramDefinitionOneComponent } from './components/program-definition-one/program-definition-one.component';
import { GeneralConditionsOneComponent } from './components/general-conditions-one/general-conditions-one.component';
import { FlexwayOneComponent } from './components/flexway-one/flexway-one.component';
import { StayCareOneComponent } from './components/stay-care-one/stay-care-one.component';
import { FlyCareOneComponent } from './components/fly-care-one/fly-care-one.component';
import { OtherBenefitsOneComponent } from './components/other-benefits-one/other-benefits-one.component';
import { CoverageInformationOneComponent } from './components/coverage-information-one/coverage-information-one.component';
import { WebsiteOneComponent } from './components/website-one/website-one.component';
import { ServiceOneComponent } from './components/service-one/service-one.component';
import { PrivacyOneComponent } from './components/privacy-one/privacy-one.component';
import { CoverageDispositionsOneComponent } from './components/coverage-dispositions-one/coverage-dispositions-one.component';

@NgModule({
  declarations: [
    AppComponent,
    WebsiteComponent,
    CardComponent,
    UpperclubComponent,
    BrandedRulesComponent,
    CyberComponent,
    PrivacyComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    FirstcitizensComponent,
    MilesUpperProgramComponent,
    MilesUpperGeneralComponent,
    MilesUpperBenefitsComponent,
    StayCareComponent,
    FlyCareComponent,
    OtherBenefitsComponent,
    ExclusionsComponent,
    CoverageComponent,
    ServiceComponent,
    GlosaryComponent,
    BestPriceComponent,
    ProgramDefinitionFcComponent,
    NcbComponent,
    ProgramDefinitionNcbComponent,
    MyrewardsComponent,
    RewardsComponent,
    RewardsAppComponent,
    VoyageComponent,
    OffersComponent,
    PrivacyNoticeComponent,
    PrivacyNoticeMrComponent,
    VoyageBenefitsComponent,
    DefinitionsComponent,
    CoverageProvisionsComponent,
    FlyAndStayComponent,
    OtherBenefitsMrComponent,
    BestPriceMrComponent,
    ExclusionsMrComponent,
    ProgramDefinitionComponent,
    MilesUseComponent,
    LifemilesComponent,
    MilesCareProtectionComponent,
    BusinessModelComponent,
    AdditionalProtectionComponent,
    MiscellaneousCoverageComponent,
    GeneralInformationComponent,
    StayCareLifeComponent,
    FlyCareLifeComponent,
    GeneralConditionsLifeComponent,
    CyberRiskComponent,
    ExclusionsLmComponent,
    CoverageProvisionsMrComponent,
    ScotiaComponent,
    GeneralConditionsScotiaComponent,
    ProgramDefinitionScotiaComponent,
    ScotiaRewardsComponent,
    CoverageProvisionsScotiaComponent,
    StayCareScotiaComponent,
    FlyCareScotiaComponent,
    OtherBenefitsScotiaComponent,
    ExclusionsScotiaComponent,
    CoverageInformationComponent,
    CredomaticComponent,
    GeneralConditionsCredomaticComponent,
    ProgramDefinitionCredomaticComponent,
    CoverageProvisionsCredomaticComponent,
    StayCareCredomaticComponent,
    FlyCareCredomaticComponent,
    GlosaryCredomaticComponent,
    OtherBenefitsCredomaticComponent,
    CyberRiskCredomaticComponent,
    CoverageCredomaticComponent,
    LifemilesParthersComponent,
    ProgramDefinitionLmpComponent,
    LifeMilesAirlineComponent,
    PrivacyNoticeLmpComponent,
    VoyageBenefitsFlyCareComponent,
    CibcComponent,
    ProgramDefinitionMrComponent,
    PrivacyNoticeCibcComponent,
    VoyageBenefitsCibcComponent,
    MoreRateComponent,
    ProgramDefinitionCibcComponent,
    ExclusionsCredomaticComponent,
    ApapComponent,
    ProgramDefinitionApapComponent,
    CyberRiskLmComponent,
    CoverageDispositionsComponent,
    WebAppCredomaticComponent,
    CareComponent,
    ProgramDefinitionCareComponent,
    ServiceCareComponent,
    OtherBenefitsCareComponent,
    ScotiaRewardsFixedComponent,
    ScotiaRewardsEnrollmentComponent,
    ScotiaRewardsCommunicationsComponent,
    WebsiteScotiaComponent,
    CoverageInformationScotiaComponent,
    GlosaryScotiaComponent,
    MilesBlueComponent,
    CibcAppComponent,
    FlexwayComponent,
    FlexwayScotiaComponent,
    RewardsApapAppComponent,
    VoyageBenefitsApapComponent,
    CyberRiskProtectionNcbComponent,
    CryptmiComponent,
    ProgramDefinitionCryptmiComponent,
    PrivacyCryptmiComponent,
    GeneralConditionsCryptmiComponent,
    StayCareCryptmiComponent,
    FlyCareCryptmiComponent,
    OtherBenefitsCryptmiComponent,
    ExclusionsCryptmiComponent,
    CoverageInformationCryptmiComponent,
    WebsiteCryptmiComponent,
    ServiceCryptmiComponent,
    GlossaryMilesBlueComponent,
    ProgramDefinitionMilesBlueComponent,
    GeneralConditionsMilesBlueComponent,
    OtherBenefitsMilesBlueComponent,
    CoverageInformationMilesBlueComponent,
    CyberRiskMilesBlueComponent,
    ServiceMilesBlueComponent,
    MilesComponent,
    ProgramDefinitionMilesComponent,
    MilesAppComponent,
    VoyageBenefitsMilesComponent,
    CoverageProvisionsMilesComponent,
    FlyAndStayMilesComponent,
    OtherBenefitsMilesComponent,
    ExclusionsMilesComponent,
    ChnComponent,
    ProgramDefinitionChnComponent,
    VoyageBenefitsChnComponent,
    CoverageProvisionsChnComponent,
    OtherBenefitsChnComponent,
    ExclusionsChnComponent,
    GenniusComponent,
    CuscatlanComponent,
    ProgramDefinitionCuscatlanComponent,
    VoyageBenefitsCuscatlanComponent,
    CoverageProvisionsCuscatlanComponent,
    FlyAndStayCuscatlanComponent,
    OtherBenefitsCuscatlanComponent,
    ExclusionsCuscatlanComponent,
    FlexwayBacComponent,
    ImagineComponent,
    ProgramDefinitionImagineComponent,
    FlexwayImagineComponent,
    WebsiteImagineComponent,
    FlyCareImagineComponent,
    CoverageDispositionsImagineComponent,
    ServiceImagineComponent,
    NcbAppComponent,
    VoyageBenefitsNcbComponent,
    OneComponent,
    GlossaryOneComponent,
    ProgramDefinitionOneComponent,
    GeneralConditionsOneComponent,
    FlexwayOneComponent,
    StayCareOneComponent,
    FlyCareOneComponent,
    OtherBenefitsOneComponent,
    CoverageInformationOneComponent,
    WebsiteOneComponent,
    ServiceOneComponent,
    PrivacyOneComponent,
    CoverageDispositionsOneComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
